export const TABLE_CONFIG_KEYS = {
  ADMIN_GATEWAYS: 'adminGateways',
  ADMIN_TAGS: 'adminTags',
  ADMIN_USERS: 'adminUsers',
  ALERTS: 'alerts',
  EVENTS: 'events',
  FARMS: 'farms',
  GATEWAYS: 'gateways',
  GEOFENCES: 'geofences',
  GRAZING: 'grazing',
  GROUPS: 'groups',
  INCLUDED_EXCLUDED_LIVESTOCK: 'includedExcludedLivestock',
  INVITATIONS: 'invitations',
  LAST_NOTIFICATIONS: 'latestNotifications',
  LIVESTOCK: 'livestock',
  LIVESTOCK_BREEDING: 'livestockBreeding',
  LIVESTOCK_COUNT: 'livestockCount',
  LIVESTOCK_MEASURES: 'livestockMeasures',
  LIVESTOCK_TREATMENTS: 'livestockTreatments',
  NOTIFICATIONS: 'notifications',
  RULES: 'rules',
  SITES: 'sites',
  TAGS: 'tags',
  TASKS: 'tasks',
  TOP_RULES: 'topRules',
  TOP_TASKS: 'topTasks',
  TRACK_LIVESTOCK: 'trackLivestock',
  UNLINKED_LIVESTOCK: 'unlinkedLivestock'
};

export const TABLE_CONFIG_COLUMNS = {
  ACTUAL_TRACKED_LIVESTOCK: 'actualTrackedLivestock',
  AGE: 'age',
  APPEUI: 'appeui',
  ARN: 'arn',
  ASSIGNED_GEOFENCE: 'assignedGeofence',
  ASSIGNED_GROUPS: 'assignedGroups',
  ASSIGNED_LIVESTOCK: 'assignedLivestock',
  ASSIGNED_USER: 'assignedUser',
  ASSIGNED_USERS: 'assignedUsers',
  BACKUP_EMAIL: 'backupEmail',
  BATTERY_STATUS: 'batteryStatus',
  BIOMASS_WEIGHT_AFTER_ROTATION: 'biomassWeightAfterRotation',
  BIOMASS_WEIGHT_BEFORE_ROTATION: 'biomassWeightBeforeRotation',
  BRAND: 'brand',
  BREED: 'breed',
  BREEDING_PLAN: 'breedingPlan',
  BREEDING_STATUS: 'breedingStatus',
  CALF_AGE: 'calfAge',
  CALF_ID: 'calfId',
  CALF_MGMT_TAG_ID: 'calfMgmtTagId',
  CALVING_PERFORMANCE: 'calvingPerformance',
  CARRYING_CAPACITY: 'carryingCapacity',
  CITY: 'city',
  CLEAR: 'clear',
  COLOUR: 'colour',
  COMMENTS: 'comments',
  CONNECTED_KRAAL_TAGS: 'connectedKraalTags',
  CONNECTION_SPEED: 'connectionSpeed',
  CONNECTION_STATUS: 'connectionStatus',
  COST: 'cost',
  COUNTRY: 'country',
  CREATED_AT: 'createdAt',
  DAM_ID: 'damId',
  DATE_SOLD: 'dateSold',
  DELETED_AT: 'deletedAt',
  DESCRIPTION: 'description',
  DEVEUI: 'deveui',
  DOB: 'dob',
  DOSAGE_AMOUNT: 'dosageAmount',
  DOSAGE_UOM: 'dosageUom',
  DUE_DATE: 'dueDate',
  DURATION: 'duration',
  EAR_MARK: 'earMark',
  EMAIL: 'email',
  EMAIL_ENABLED: 'emailEnabled',
  EMAIL_VERIFIED_AT: 'emailVerifiedAt',
  END_DATE: 'endDate',
  EVENT_DESCRIPTION: 'eventDescription',
  EVENT_ID: 'eventId',
  EVENT_TYPE: 'eventType',
  EXCEPTIONS: 'exceptions',
  EXPECTED_CALVING_DATE: 'expectedCalvingDate',
  EXPECTED_TRACKED_LIVESTOCK: 'expectedTrackedLivestock',
  EXPIRES_DATE: 'expiresDate',
  FARM: 'farm',
  FARM_ADDRESS: 'address',
  FARM_ID: 'farm_id',
  FARM_IDENTIFIER: 'farmIdentifier',
  FIRMWARE_VERSION: 'firmwareVersion',
  FIRST_NAME: 'firstName',
  FORAGE_COVER_AFTER_ROTATION: 'forageCoverAfterRotation',
  FORAGE_COVER_BEFORE_ROTATION: 'forageCoverBeforeRotation',
  FORAGE_HEIGHT_AFTER_ROTATION: 'forageHeightAfterRotation',
  FORAGE_HEIGHT_BEFORE_ROTATION: 'forageHeightBeforeRotation',
  FORAGE_SPECIES: 'forageSpecies',
  GATEWAY_IDENTIFIER: 'gatewayIdentifier',
  GATEWAY_NAME: 'gatewayName',
  GEOFENCE: 'geofence',
  GWEUI: 'gweui',
  HOLDING_NUMBER: 'holdingNumber',
  HOUSE_NUMBER: 'houseNumber',
  ID: 'id',
  IS_INCLUDED: 'isIncluded',
  PHYSICAL_GROUP: 'physicalGroup',
  IS_LINKED: 'is_linked',
  IS_POSITIVE: 'isPositive',
  IS_PREGNANT: 'isPregnant',
  KRAAL_TAG_ID: 'kraalTagId',
  LAST_NAME: 'lastName',
  LAST_READING: 'lastReading',
  LAST_ROTATION_DURATION: 'lastRotationDuration',
  LAST_ROTATION_END_DATE: 'lastRotationEndDate',
  LAST_ROTATION_START_DATE: 'lastRotationStartDate',
  LAST_ROTATION_STOCKING_RATE: 'lastRotationStockingRate',
  LAT: 'lat',
  LINKED_ACCOUNT: 'linked_account',
  LINKED_STATUS: 'linkedStatus',
  LIVESTOCK_COUNT: 'livestockCount',
  LIVESTOCK_DIFFERENCE: 'livestockDifference',
  LIVESTOCK_ID: 'livestockId',
  LIVESTOCK_TYPE: 'livestockType',
  LNG: 'lng',
  LOCATION: 'location',
  LORA_SIGNAL_STRENGTH: 'loraSignalStrength',
  LOSS_DATE: 'lossDate',
  LOSS_REASON: 'lossReason',
  LSU_DAYS_GRAZING: 'lsuDaysGrazing',
  MAJOR_MEASURE_TYPE: 'majorMeasureType',
  MATERNITY_PERFORMANCE: 'maternityPerformance',
  MATING_TYPE: 'matingType',
  MEASUREMENT: 'measurement',
  MEASUREMENT_DATE: 'measurementDate',
  MEASURE_ID: 'measureId',
  MEDICATION: 'medication',
  MESSAGE: 'message',
  MGMT_TAG_ID: 'mgmtTagId',
  MINOR_MEASURE_TYPE: 'minorMeasureType',
  NAME: 'name',
  NEXT_ROTATION_DAYS_GRAZED: 'nextRotationDaysGrazed',
  NEXT_ROTATION_DURATION: 'nextRotationDuration',
  NEXT_ROTATION_END_DATE: 'nextRotationEndDate',
  NEXT_ROTATION_START_DATE: 'nextRotationStartDate',
  NEXT_ROTATION_STOCKING_RATE: 'nextRotationStockingRate',
  NOTIFICATION_TRIGGER_DATE: 'notificationTriggerDate',
  NUMBER: 'number',
  NUM_OF_CALVES: 'numOfCalves',
  NUM_OF_LIVESTOCK: 'numOfLivestock',
  OBJECTS: 'objects',
  OFFICIAL_TAG_ID: 'officialTagId',
  PASTURE_NAME: 'pastureName',
  PERIMETER: 'perimeter',
  PLAN: 'plan',
  POLLED: 'polled',
  POSTAL_CODE: 'postalCode',
  PRIORITY: 'priority',
  PRIVATE_PHONE: 'privatePhone',
  PURCHASE_DATE: 'purchaseDate',
  PURCHASE_FROM: 'purchaseFrom',
  PURCHASE_NOTES: 'purchaseNotes',
  PURCHASE_WHERE: 'purchaseWhere',
  REPEAT_DATE: 'repeatDate',
  REST_SINCE_LAST_ROTATION: 'restSinceLastRotation',
  REST_UNTIL_NEXT_ROTATION: 'restUntilNextRotation',
  RESULT: 'result',
  REVIEW_DATE: 'reviewDate',
  ROLES: 'roles',
  ROLE_NAME: 'roleName',
  ROTATION_LSU_DAYS_GRAZING: 'rotationLsuDaysGrazing',
  RULE: 'rule',
  SEX: 'sex',
  SIRE_ID: 'sireId',
  SITE_RULES: 'siteRules',
  SIZE: 'size',
  SMS_COUNT: 'smsCount',
  SMS_ENABLED: 'smsEnabled',
  SNOOZE: 'snooze',
  SOLD_TO: 'soldTo',
  SOLD_WHEN: 'soldWhen',
  SPECIE: 'specie',
  START_AT: 'startAt',
  START_DATE: 'startDate',
  STATUS: 'status',
  STOCKING_RATE: 'stockingRate',
  STRAWS: 'straws',
  STRAW_REF: 'strawRef',
  STREET: 'street',
  SYMPTOMS: 'symptoms',
  TIME: 'time',
  TITLE: 'title',
  TREATMENT: 'treatment',
  TREATMENT_DATE: 'treatmentDate',
  TREATMENT_ID: 'treatmentId',
  TREATMENT_TYPE: 'treatmentType',
  TRIGGERS: 'triggers',
  TRIGGERS_COUNT: 'triggersCount',
  TYPE: 'type',
  UNASSIGNED_LIVESTOCK: 'unassignedLivestock',
  UOM: 'uom',
  UPDATED_AT: 'updatedAt',
  USER_ROLE_STATUS: 'userRoleStatus',
  VERSION: 'version',
  VET: 'vet',
  WEIGHT: 'weight',
  WORK_PHONE: 'workPhone'
};
